:host {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f6fd;
  background: var(--bg-blue-manager);
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
  z-index: 1;

  .hide {
    display: none !important;
  }

  p {
    margin: 15px 0;
  }

  h1 {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 500;
  }

  h2 {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 500;
  }

  h3 {
    display: block;
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 500;
  }
  h4 {
    display: block;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 500;
  }

  ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }

  * {
    box-sizing: border-box;
    &:focus {
      outline: none;
    }
  }

  strong {
    font-weight: 500;
  }

  .flex {
    display: flex;
  }

  .align-center {
    align-items: center;
  }

  .hide {
    display: none !important;
  }

  #support-faq__view {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    transition: left 0.5s;
    background: white;
    background: var(--bg-primary);
    line-height: 20px;
    bottom: 0;
    border-radius: 0 8px;
    color: #333333;
    color: var(--font-primary);

    #support-faq__buttons {
      width: 100%;
      padding-bottom: 0;
    }

    li {
      font-size: 14px;
    }

    a {
      color: #0098ff;
      color: var(--blue);
      text-decoration: none;
      font-weight: 400;
    }

    .hide-faq-view {
      left: 100% !important;
      display: none;
    }

    #support-faq__search {
      position: relative;
      top: -20px;
      left: -20px;
      width: calc(100% + 40px);
    }
  }

  #faq-view__title {
    padding: 50px 30px;
    margin-bottom: 30px;
    margin-left: -20px;
    width: calc(100% + 40px) !important;
    min-height: 190px;
    display: flex;
    align-items: center;
    margin-top: -20px;
    position: relative;
    background: linear-gradient(45deg, #1251d4 0%, #4cccdf 100%);
    color: white;
    overflow: hidden;
  }

  .rectangle-copy {
    position: absolute;
    right: 30px;
    bottom: 20px;
    height: 59px;
    width: 59px;
    opacity: 0.28;
    border-radius: 4px;
    background-color: #80ffd0;
  }

  .rectangle-copy-2 {
    position: absolute;
    right: 15px;
    bottom: 65px;
    height: 31px;
    width: 31px;
    opacity: 0.28;
    border-radius: 4px;
    background-color: #80ffd0;
  }

  .rectangle-copy-7 {
    position: absolute;
    bottom: -10px;
    left: 30px;
    box-sizing: border-box;
    height: 47px;
    width: 48px;
    border: 2px solid #ffffff;
    opacity: 0.31;
    border-radius: 4px;
  }

  .rectangle-copy-8 {
    position: absolute;
    bottom: 45px;
    left: 25px;
    box-sizing: border-box;
    height: 11px;
    width: 11px;
    border: 2px solid #ffffff;
    opacity: 0.09;
    border-radius: 1px;
  }

  .faq-header-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    h2 {
      margin-top: 0px;
      margin-bottom: 0px;
      font-size: 21px;
      font-weight: 400;
      text-align: center;
      line-height: 25px;
      color: white;
    }
  }

  .faq-services-list {
    text-align: center;
    width: 100%;

    .faq-service {
      display: inline-block;
      margin: 10px 5px 0px;
      font-size: 11px;
      padding: 2px 5px;
      border-radius: 4px;
      background-color: rgb(240, 240, 240);
      color: #666666;
    }
  }

  #faq-view__description {
    img {
      max-width: 100%;
      height: auto;
      object-fit: contain;
      object-position: top;
    }
    table {
      table-layout: fixed;
      border-collapse: collapse;
    }
    th,
    td {
      padding: 5px;
      text-align: left;
    }
    thead,
    th {
      background-color: #5e6981;
      background-color: var(--secondary-color);
      color: #fff;
      color: var(--font-primary--invert);
    }
    tr {
      border-bottom: 1px solid #9f9f9f;
      border-bottom: 1px solid var(--scrollbar);

      &:first-of-type,
      &:last-of-type {
        border: none;
      }
    }
    tbody {
      display: block;
      overflow: auto;
      width: 100%;
    }
    tbody tr:nth-child(even) {
      background-color: #f4f6fd;
      background-color: var(--bg-title);
    }

    .alert {
      border-left: 10px solid #f44336;
      padding: 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.22);
      margin: 20px 0;
    }

    h2 {
      color: #333333;
      color: var(--font-primary);
      font-size: 20px;
      font-weight: 500;
    }

    h4 {
      font-weight: 500;
      font-size: 16px;
    }

    ol li {
      counter-increment: leaderboard;
      position: relative;
      margin-bottom: 10px;
      list-style: none;
    }

    ol li ol li {
      counter-increment: leaderboard2;
    }

    ol li::before {
      content: counter(leaderboard);
      position: absolute;
      z-index: 2;
      top: 0;
      left: -25px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      color: var(--font-primary--invert);
      background: #e91e63;
      background: var(--red);
      border-radius: 20px;
      font-size: 12px;
      text-align: center;
    }

    ol li ol li::before {
      content: counter(leaderboard2);
      position: absolute;
      z-index: 2;
      top: 0;
      left: -25px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      color: var(--font-primary--invert);
      background: #e91e63;
      background: var(--red);
      border-radius: 20px;
      font-size: 12px;
      text-align: center;
    }

    ul li {
      position: relative;
      margin-bottom: 10px;
      list-style: none;
    }

    ul li::before {
      content: '';
      position: absolute;
      z-index: 2;
      top: 6px;
      left: -15px;
      width: 8px;
      height: 8px;
      background: #e91e63;
      background: var(--red);
      border-radius: 50%;
    }

    iframe {
      max-width: 100%;
    }
  }

  #faq-utility-voted {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  #faq-utility-voted svg {
    margin-right: 10px;
    fill: #3c763d;
  }

  #faq-utility {
    #faq-utility-buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        img {
          filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
            contrast(109%);
          filter: var(--icon-blue);
          width: 15px;
          margin-right: 10px;
        }

        &:hover {
          transition: all 0.3s;
          background-color: #0098ff;
          background-color: var(--blue);
          color: white;

          img {
            filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
              contrast(105%);
            filter: var(--icon-white);
            transform: scale(1.3);
          }
        }

        &:nth-child(2) {
          border: none;
          color: #666666;
          color: var(--font-secondary);

          img {
            transform: rotate(180deg);
            filter: invert(42%) sepia(0%) saturate(1920%) hue-rotate(236deg) brightness(95%)
              contrast(98%);
            filter: var(--icon-font-secondary);
          }

          &:hover {
            background: transparent;
            color: #a94442;
            color: var(--red);

            img {
              transition: all 0.3s;
              filter: invert(35%) sepia(92%) saturate(513%) hue-rotate(314deg) brightness(78%)
                contrast(87%);
              filter: var(--icon-red);
            }
          }
        }
      }
    }

    h4 {
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      color: #333333;
      color: var(--font-primary);
    }

    button {
      box-sizing: border-box;
      border: 1px solid #0098ff;
      border: 1px solid var(--blue);
      border-radius: 4px;
      background-color: transparent;
      color: #0098ff;
      color: var(--blue);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 0 20px;
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s;
    }
  }

  #faq-utility-voted {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  #faq-utility-voted svg {
    margin-right: 10px;
    fill: #3c763d;
  }

  .separator {
    width: 100%;
    border-top: 2px solid #e0e0e0;
    border-top: 2px solid var(--divider);
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .separator-small {
    border-top: 2px solid #e0e0e0;
    border-top: 2px solid var(--divider);
    margin-top: 30px;
    width: 10%;
    margin: 30px auto;
  }

  .faq-url {
    text-align: center;
    margin-top: 30px;
    font-weight: 500;
    margin-bottom: 20px;

    a {
      margin-left: 5px;
    }
  }

  #support-faq__buttons {
    width: 100%;
    height: auto;
    flex-direction: column;
    border-top: 1px solid rgb(237, 236, 236);
    border-top: 1px solid var(--divider);
    height: 80px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: bottom 0.3s ease 0s;
    background: white;
    background: var(--bg-primary);
  }

  #support-button__faqs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    &.center {
      justify-content: center;
    }
  }

  #support-buttons__all a {
    font-size: 14px;
    color: #666;
    color: var(--font-secondary);
  }

  #support-buttons__all button {
    background: none;
    font-size: 14px;
    font-weight: 400;
    border: none;
    cursor: pointer;
    text-decoration: underline;
    color: #666;
    color: var(--font-secondary);
    transition: all 0.3s;
  }

  #support-buttons__all button:hover {
    color: black;
  }

  #support-buttons__contact button,
  #support-buttons__back-faq button {
    background-color: #0098ff;
    background-color: var(--blue);
    color: white;
    text-transform: uppercase;
    padding: 10px 15px;
    border-radius: 2px;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    box-shadow: none;
    font-weight: 400;
  }

  #support-buttons__contact button:hover,
  #support-buttons__back-faq button:hover {
    transition: all 0.3s;
    background-color: #0089e6;
  }

  // Inspired by https://faq.infomaniak.com
  code {
    padding: 2px 4px;
    font-family: monospace;
    font-size: 15px;
    color: #c7254e;
    background-color: #f9f2f4;
    border-radius: 4px;
    letter-spacing: 0.5px;
  }
  pre {
    overflow-x: auto;
    max-width: 100%;
    white-space: pre;
    code {
      &.language-plaintext {
        display: block;
        padding: 9.5px;
        font-size: 15px;
        max-width: fit-content;
        font-family: monospace;
        line-height: 1.6;
        letter-spacing: 0.5px;
        color: #333;
        background-color: #f5f5f5;
      }
    }

    &:has(code.language-plaintext) {
      background-color: #f5f5f5;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
  }

  @media screen and (max-width: 768px) {
    #support-buttons__back-faq {
      margin-bottom: 20px;
    }

    #faq-no-result {
      margin-bottom: 20px;
    }

    .faq-container-go-to {
      display: none;
    }

    #support-faq__buttons {
      width: 100%;
      height: auto;
      flex-direction: column;
    }

    #support-button__faqs {
      flex-direction: column;
    }

    #support-buttons__all {
      margin-bottom: 20px;
    }

    #support-faq {
      height: 100%;
    }

    #support-faq__search {
      padding: 20px;
    }

    #support-faq__list {
      /* height: calc(100% - 140px); */
      padding: 20px;
    }

    #support-list__list ul li span {
      font-size: 18px;
      line-height: normal;
    }

    #support-list__list,
    #support-faq__search {
      width: 100%;
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                FULL VERSION                                */
  /* -------------------------------------------------------------------------- */
  .support-faq__view--full {
    border-radius: 6px;
    scrollbar-width: none; /* For Firefox */
    -ms-overflow-style: none; /* For Internet Explorer and Edge */

    &::-webkit-scrollbar {
      width: 0px; /* For Chrome, Safari, and Opera */
    }
  }
}
